import {configureStore} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootSaga from "../saga/rootSage";
import {rootReducer} from "../slices/rootReducer";

const sagaMiddleware = createSagaMiddleware();

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(sagaMiddleware)
  });
}

export const store = setupStore()
sagaMiddleware.run(rootSaga);


